import React, { useState, useRef } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { getCuisines } from "../../../../store/slices/config";
import { useDispatch } from "react-redux";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { editEvents, getEvents } from "../../../../store/slices/clientprofile";
import { Link } from "react-router-dom";
import Modal2 from "../../auth_screens/Modal2";
import SuccessModal from "../../auth_screens/SuccessModal";

function EditEvent() {
  const [cuisines, setCuisines] = useState([]);
  const [selectedCuisines, setSelectedCuisines] = useState([]);
  const [city, setCity] = useState("");
  const [location, setLocation] = useState("");
  const [eventType, setEventType] = useState("");
  const [eventDate, setEventDate] = useState("");
  const [dishes, setDishes] = useState("");
  const [expectedGuest, setexpectedGuest] = useState("");
  const [pincode, setPincode] = useState("");
  const [errors, setErrors] = useState({});
  const [cityCoord, setCityCoord] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [successModal, setsuccessModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [isdisabled, setisDisabled] = useState(false);
  const [locationCoord, setLocationCoord] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const eventTypeRef = useRef(null);
  const dateRef = useRef(null);
  const cuisinesRef = useRef(null);
  const dishesRef = useRef(null);
  const guestsRef = useRef(null);
  const pincodeRef = useRef(null);

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    document.title = "CookandChef | Edit Event";
  }, []);

  const date = new Date();
  date.setDate(date.getDate() + 1);

  const tommorrow = date.toISOString().split("T")[0];

  useEffect(() => {
    dispatch(getEvents(id))
      .unwrap()
      .then((data) => {
        setCity(data?.user?.data[0].city);
        setSelectedCuisines(data?.user?.data[0].cuisines);
        setEventDate(data?.user?.data[0].eventDate);
        setEventType(data?.user?.data[0].eventType);
        setDishes(data?.user?.data[0].dishes);
        setexpectedGuest(data?.user?.data[0].expectedGuest);
        setPincode(data?.user?.data[0].pincode);
        setLocation(data?.user?.data[0].location);
        setLocationCoord(data?.user?.data[0].locationCoordinates.coordinates);
        setCityCoord(data?.user?.data[0].cityCoordinates.coordinates);
      })
      .catch((err) => {
        setModalMessage(err);
        setShowModal(true);
      });
  }, []);

  const isValidName = (name) => {
    // validating the name with one cap letter and 6 char of length
    return /^(?=.*[a-zA-Z])[a-zA-Z0-9'@& -_]{4,}$/.test(name);
  };
  const isValidcurrentCity = (currentCityName) => {
    return /^[a-zA-Z0-9& ]{1,100}$/.test(currentCityName);
  };

  const isValidPincode = (pincode) => {
    // validating the name with one cap letter and 6 char of length
    return /^[1-9][0-9]{5}$/.test(pincode);
  };

  const isValidGuests = (expectedGuest) => {
    return /^(1[0-9]{1,3}|[2-9][0-9]{1,3}|10000)$/.test(expectedGuest);
  };

  const isValidDish = (dishes) => {
    return /^[a-zA-Z0-9\- ',&@]{2,100}$/.test(dishes);
  };
  const submitHandler = (e) => {
    e.preventDefault();
    setisDisabled(true);
    setTimeout(() => {
      setisDisabled(false);
    }, 3000);
    const validationErrors = {};
    if (!selectedCuisines.length) {
      validationErrors.cuisines = "कृपया कम से कम एक व्यंजन दर्ज करें";
    }
    if (!city) {
      validationErrors.city = "कृपया शहर का नाम दर्ज करें";
    } else if (!isValidcurrentCity(city) || !cityCoord?.length) {
      validationErrors.city = "कृपया मान्य शहर का नाम दर्ज करें";
    }
    if (!location) {
      validationErrors.location = "कृपया ईवेंट स्थान दर्ज करें";
    } else if (!isValidcurrentCity(location) || !locationCoord?.length) {
      validationErrors.location = "कृपया मान्य स्थान दर्ज करें";
    }
    if (!eventDate) {
      validationErrors.eventDate = "कृपया ईवेंट दिनांक दर्ज करें";
    }
    if (dishes !== "" && !isValidDish(dishes)) {
      validationErrors.dishes = "कृपया वैध व्यंजन दर्ज करें";
    }
    if (!eventType) {
      validationErrors.eventType = "कृपया ईवेंट प्रकार दर्ज करें";
    } else if (!isValidName(eventType)) {
      validationErrors.eventType =
        "इवेंट प्रकार कम से कम 3 अक्षर का होना चाहिए";
    }
    if (!dishes) {
      validationErrors.dishes = "कृपया कम से कम एक डिश दर्ज करें";
    }
    if (!expectedGuest) {
      validationErrors.expectedGuest =
        "कृपया मेहमानों का अपेक्षित संख्या दर्ज करें";
    } else if (!isValidGuests(expectedGuest)) {
      validationErrors.expectedGuest =
        "अतिथियों की संख्या 10 से अधिक तथा 10,000 से कम होनी चाहिए";
    }
    if (!pincode) {
      validationErrors.pincode = "कृपया पिनकोड दर्ज करें";
    } else if (!isValidPincode(pincode)) {
      validationErrors.pincode = "कृपया एक वैध पिनकोड दर्ज करें";
    }
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      if (validationErrors.eventType) {
        eventTypeRef.current.focus();
      } else if (validationErrors.eventDate) {
        dateRef.current.focus();
      } else if (validationErrors.cuisines) {
        cuisinesRef.current.querySelector(".input1 input").focus();
      } else if (validationErrors.dishes) {
        dishesRef.current.focus();
      } else if (validationErrors.expectedGuest) {
        guestsRef.current.focus();
      } else if (validationErrors.location) {
        locationinpuutref.current.focus();
      } else if (validationErrors.pincode) {
        pincodeRef.current.focus();
      } else if (validationErrors.cityName) {
        cityinputRef.current.focus();
      }

      return;
    } else {
      const pin = Number(pincode);
      const item = {
        id: id,
        eventType: eventType || undefined,
        eventDate: eventDate.toString().split("T")[0] || undefined,
        cuisines: selectedCuisines || undefined,
        expectedGuest: expectedGuest || undefined,
        pincode: pin || undefined,
        city: city || undefined,
        location: location || undefined,
        locationCoordinates:
          {
            type: "Point",
            coordinates: locationCoord,
          } || undefined,
        cityCoordinates:
          {
            type: "Point",
            coordinates: cityCoord,
          } || undefined,
        dishes: dishes || undefined,
      };

      dispatch(editEvents(item))
        .unwrap()
        .then((data) => {
          setModalMessage("इवेंट सफलतापूर्वक संपादित हुआ");
          setsuccessModal(true);
          setTimeout(() => {
            navigate("/hin/client/events");
          }, 3000);
        })
        .catch(({ message }) => {
          setModalMessage(message);
          setShowModal(true);
        });
    }
  };

  React.useEffect(() => {
    dispatch(getCuisines())
      .unwrap()
      .then((data) => {
        setCuisines(data.user.data);
      })
      .catch(({ message }) => {
        // setModalMessage(message);
        // setShowModal(true);
      });
  }, [dispatch]);

  var cuisinoptions = cuisines.map(function (item) {
    return item["cuisineName"];
  });
  const locationinpuutref = useRef(null);

  useEffect(() => {
    if (locationinpuutref.current) {
      const autoCompleteCity = new window.google.maps.places.Autocomplete(
        locationinpuutref.current,
        {
          componentRestrictions: { country: "in" },
        }
      );

      autoCompleteCity.addListener("place_changed", () => {
        const place = autoCompleteCity.getPlace();

        if (!place.geometry || !place.geometry.location) {
          setErrors({
            ...errors,
            location: "कृपया सुझाव ड्रॉप-डाउन से स्थान चुनें",
          });
          setLocationCoord([]);
        } else {
          setErrors({
            ...errors,
            location: "",
          });
          const coordinates = [
            place.geometry.location.lng(),
            place.geometry.location.lat(),
          ];

          setLocation(place.name);
          setLocationCoord(coordinates);
        }
      });
      locationinpuutref.current.addEventListener("blur", () => {
        const place = autoCompleteCity.getPlace();
        const inputValue = locationinpuutref.current.value.trim();

        if (inputValue && (!place?.geometry || !place?.geometry?.location)) {
          setErrors({
            ...errors,
            location: "कृपया सुझाव ड्रॉप-डाउन से स्थान चुनें",
          });
          setLocationCoord([]);
        }
      });
    }
  }, []);

  const cityinputRef = useRef(null);

  useEffect(() => {
    if (cityinputRef.current) {
      const autoCompleteCity = new window.google.maps.places.Autocomplete(
        cityinputRef.current,
        {
          componentRestrictions: { country: "in" },
        }
      );

      autoCompleteCity.addListener("place_changed", () => {
        const place = autoCompleteCity.getPlace();

        if (!place.geometry || !place.geometry.location) {
          setErrors({
            ...errors,
            city: "कृपया सुझाव ड्रॉप-डाउन से स्थान चुनें",
          });
          setCityCoord([]);
        } else {
          setErrors({
            ...errors,
            city: "",
          });
          const coordinates = [
            place.geometry.location.lng(),
            place.geometry.location.lat(),
          ];

          setCity(place.name);
          setCityCoord(coordinates);
        }
      });
      cityinputRef.current.addEventListener("blur", () => {
        const place = autoCompleteCity.getPlace();

        const inputValue = cityinputRef.current.value.trim();

        if (inputValue && (!place?.geometry || !place?.geometry?.location)) {
          setErrors({
            ...errors,
            city: "कृपया सुझाव ड्रॉप-डाउन से स्थान चुनें",
          });
          setCityCoord([]);
        }
      });
    }
  }, []);

  const handleChange = (e) => {
    const validationErrors = { ...errors };
    const { name, value } = e.target;
    switch (name) {
      case "city":
        setCity(value);
        validationErrors[name] =
          value === "" ? "कृपया मान्य शहर का नाम दर्ज करें" : "";
        if (value !== "" && isValidcurrentCity(value)) {
          validationErrors[name] = "";
        }
        break;
      case "eventType":
        setEventType(value);
        validationErrors[name] =
          value === "" || !isValidName(value)
            ? "Event type should be atleast  3 characters"
            : "";
        if (value !== "" && isValidName(value)) {
          validationErrors[name] = "";
        }
        break;
      case "location":
        setLocation(value);
        validationErrors[name] =
          value === "" ? "कृपया मान्य स्थान दर्ज करें" : "";
        if (value !== "" && isValidcurrentCity(value)) {
          validationErrors[name] = "";
        }
        break;
      case "dishes":
        setDishes(value);
        validationErrors[name] =
          value === "" || !isValidDish(value)
            ? "कृपया वैध व्यंजन दर्ज करें"
            : "";
        if (value !== "" && isValidDish(value)) {
          validationErrors[name] = "";
        }
        break;

      case "eventDate":
        setEventDate(value);
        validationErrors[name] =
          value === "" ? "कृपया ईवेंट दिनांक दर्ज करें" : "";
        if (value !== "") {
          validationErrors[name] = "";
        }
        break;

      case "pincode":
        setPincode(value);
        validationErrors[name] =
          value === "" || isValidPincode(value)
            ? "पिनकोड कम से कम 6 अंकों का होना चाहिए"
            : "";
        if (value !== "" && isValidPincode(value)) {
          validationErrors[name] = "";
        }
        break;

      case "expectedGuest":
        setexpectedGuest(value);
        validationErrors[name] =
          value === "" || isValidGuests(value)
            ? ""
            : "अपेक्षित अतिथि 10 और 10000 से अधिक होने चाहिए";
        if (!value === "" && isValidGuests(value)) {
          delete validationErrors[name];
        }
        break;
      default:
        break;
    }
    setErrors(validationErrors);
  };

  const handleCuisineChange = (selectedOptions) => {
    setSelectedCuisines(selectedOptions);
    const isValid = validateCuisines(selectedOptions);
    setErrors((prevErrors) => ({
      ...prevErrors,
      cuisines: isValid ? "" : "कृपया कम से कम एक व्यंजन चुनें",
    }));
  };

  const validateCuisines = (selectedOptions) => {
    return selectedOptions.length > 0;
  };
  const currentDate = new Date().toISOString().split("T")[0];
  const openDatePicker = () => {
    const dateInput = document.getElementById("session-date");
    dateInput.showPicker();
  };
  return (
    <>
      <Modal2
        showModal={showModal}
        modalMessage={modalMessage}
        setShowModal={setShowModal}
      />
      <SuccessModal
        showModal={successModal}
        modalMessage={modalMessage}
        setsuccessModal={setsuccessModal}
      />
      <div
        className="text-start my-4"
        style={{
          fontSize: "14px",
          fontWeight: "600",
          color: "#ff5c09",
        }}
      >
        <Link to="/hin/client/dashboard" className="bcrumb">
          डैशबोर्ड
        </Link>
        &nbsp;&bull; इवेंट एडिट करें
      </div>
      <Form autoComplete="off" noValidate onSubmit={submitHandler}>
        <Row className="mt-4 gx-3 d-flex justify-content-center ">
          <Col lg={12} xs={11} className="mb-4">
            <Row className="=d-flex justify=-content-center align-items-center">
              <div
                style={{
                  height: "100%",
                  width: "100%",
                  backgroundColor: "white",
                  borderRadius: "15px",
                  padding: "20px 40px",
                }}
              >
                <Row>
                  <Col lg={6} sm={12}>
                    <Form.Group className="my-2">
                      <label className="mb-2 label">ईवेंट प्रकार *</label>
                      <Form.Control
                        className="input1"
                        name="eventType"
                        value={eventType}
                        onChange={handleChange}
                        type="text"
                        isInvalid={!!errors.eventType}
                        isValid={!errors.eventType && eventType.length > 0}
                        ref={eventTypeRef}
                        placeholder="e.g Marriage, Birthday"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.eventType}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col lg={6} sm={12}>
                    <Form.Group className="my-2">
                      <label className="mb-2 label">ईवेंट दिनांक *</label>
                      <div
                      style={{ position: "relative" }}
                      onClick={openDatePicker}
                    >
                      <Form.Control
                        name="eventDate"
                        value={eventDate}
                        onChange={handleChange}
                 
                        className="input1"
                        type="date"
                        id="session-date"
                        min={tommorrow}
                          isInvalid={!!errors.eventDate}
                          ref={dateRef}
                        placeholder="Enter event date"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.eventDate}
                      </Form.Control.Feedback>
                      </div>
                    </Form.Group>
                  </Col>

                  <Col lg={6} sm={12}>
                    <Form.Group className="my-2">
                      <label className="mb-2 label">व्यंजन *</label>
                      <div ref={cuisinesRef}>
                        <Typeahead
                          id="basic-typeahead-multiple"
                          labelKey="cuisineName"
                          multiple
                          className="input1"
                          onChange={handleCuisineChange}
                          options={cuisinoptions}
                          placeholder="North Indian, South Indian"
                          selected={selectedCuisines}
                        />
                      </div>
                      <p style={{ color: "#DC3545", fontSize: "14px" }}>
                        {errors.cuisines}
                      </p>
                    </Form.Group>
                  </Col>

                  <Col lg={6} sm={12}>
                    <Form.Group className="my-2">
                      <label className="mb-2 label">डिश *</label>
                      <Form.Control
                        className="input1"
                        name="dishes"
                        value={dishes}
                        onChange={handleChange}
                        type="text"
                        isInvalid={!!errors.dishes}
                        isValid={!errors.dishes && dishes.length > 0}
                        ref={dishesRef}
                        placeholder="Nan, Paneer"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.dishes}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col lg={6} sm={12} className="my-2">
                    <Form.Group className="my-2">
                      <label className="mb-2 label">अपेक्षित अतिथि *</label>
                      <Form.Control
                        name="expectedGuest"
                        value={expectedGuest}
                        onChange={handleChange}
                        ref={guestsRef}
                        isInvalid={!!errors.expectedGuest}
                        isValid={
                          !errors.expectedGuest && expectedGuest.length > 0
                        }
                        className="input1"
                        type="text"
                        placeholder="1000"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.expectedGuest}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col lg={6} sm={12}>
                    <Form.Group className="my-2">
                      <label className="mb-2 label">स्थान *</label>
                      <Form.Control
                        name="location"
                        value={location}
                        onChange={handleChange}
                        isInvalid={!!errors.location}
                        isValid={!errors.location && location.length > 0}
                        className="input1"
                        type="text"
                        ref={locationinpuutref}
                        placeholder="Hebbal"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.location}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col lg={6} sm={12} className="my-2">
                    <Form.Group className="my-2">
                      <label className="mb-2 label">पिनकोड *</label>
                      <Form.Control
                        name="pincode"
                        value={pincode}
                        onChange={handleChange}
                        isInvalid={!!errors.pincode}
                        isValid={!errors.pincode && pincode.length > 0}
                        className="input1"
                        ref={pincodeRef}
                        type="text"
                        placeholder="110011"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.pincode}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col lg={6} sm={12}>
                    <Form.Group className="my-2">
                      <label className="mb-2 label">शहर *</label>
                      <Form.Control
                        name="city"
                        value={city}
                        onChange={handleChange}
                        isInvalid={!!errors.city}
                        isValid={!errors.city && city.length > 0}
                        className="input1"
                        type="text"
                        ref={cityinputRef}
                        placeholder="Bangalore, Mumbai"
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.city}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="d-flex justify-content-center mt-4">
                  <Col lg={5} xs={8}>
                    <div className="d-flex justify-content-around my-2 align-items-center">
                      <Button
                        className="cancelBtn"
                        onClick={() => navigate(-1)}
                      >
                        रद्द कीजिये
                      </Button>
                      <Button
                        type="submit"
                        disabled={isdisabled}
                        className="saveBtn ms-2"
                      >
                        जमा करना
                      </Button>
                    </div>
                  </Col>
                </Row>
              </div>
            </Row>
          </Col>
        </Row>
      </Form>
    </>
  );
}

export default EditEvent;
